import { injectable } from 'tsyringe';
import { NoRecommendationReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  conditionType,
  ConditionType,
} from './decrators/condition-type.decorator';
import { LoggerService } from '../../../../shared/services/logger.service';
import { OWInternalSettingsWrapper } from '../../../ow-odk-wrappers/ow-internal-settings-wrapper';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Global)
export class GlobalConditionInGameRecommendationsDisabled
  implements ICondition
{
  private readonly logger = LoggerService.getCategory(
    'GlobalConditionInGameRecommendationsDisabled',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly owInternalSettingsWrapper: OWInternalSettingsWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  shouldSkip(context: ConditionContext) {
    return false;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    try {
      const isDisabled =
        await this.owInternalSettingsWrapper.getDisableInGameRecommendations();

      if (isDisabled === true) {
        this.logger.info('In-game recommendations are disabled.');
        return [false, NoRecommendationReasons.InGameRecommendationsDisabled];
      }

      return [true];
    } catch (error) {
      this.logger.error(
        'Failed to check disableInGameRecommendations setting:',
        error,
      );
      // In case of error, allow recommendations to proceed
      return [true];
    }
  }
}
